var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","background-repeat":"no-repeat","background-size":"cover"},style:({
    backgroundColor: _vm.zone.color,
    color: _vm.zone.textColor,
    fontSize: _vm.fontSize,
    top: (_vm.top + "px"),
    right: (_vm.right + "px"),
    width: (_vm.width + "px"),
    height: (_vm.height + "px"),
    backgroundImage: _vm.zone.background ? ("url('" + (_vm.zone.background) + "')") : null,
  }),attrs:{"id":((_vm.zone.zoneID) + "_" + (_vm.zone.zoneName))}},[(_vm.showInfo)?_c('div',{staticStyle:{"position":"absolute","color":"white","background-color":"#CCCCCC80","padding":"5px 10px"}},[_vm._v(_vm._s(_vm.zone.zoneID)+" - "+_vm._s(_vm.zone.zoneName))]):_vm._e(),(_vm.contents)?_c('custom-carousel',{attrs:{"contents":_vm.contents,"onEnd":_vm.handleCarouselEnd,"zone":_vm.zone.zoneName,"backgroundImage":_vm.background,"lmu":_vm.lmu}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }